import React from 'react'
import Header from './Components/Header'
import MainHeader from './Components/MainHeader'
// import Breadcrump from './Components/Breadcrump'
import About from './Components/About'
// import Stepper from './Components/Stepper'
// import OurTeam from './Components/OurTeam'
// import LeftRightSection from './Components/LeftRightSection'
import Footer from './Components/Footer'
import ServicesCTABanner from './Components/ServicesCTABanner'
import Hero2 from './Components/Hero2'
import TrustCertifications from './Components/TrustCertifications'
import WhyChooseUsSection from './Components/WhyChooseUsSection'
import SEOHelmet from './Components/SEOHelmet'

const aboutus = () => {
    return (
        <div className="AboutUs">
            <SEOHelmet
                title="About Octalbees – Your Digital Technology Partner"
                description="Octalbees is a team of creative minds, strategic thinkers, and technology enthusiasts. We build digital experiences that drive growth and create lasting impact."
                path="/about-us"
            />
            <Header />
            <MainHeader />
            {/* <Breadcrump /> */}
            <About />
            <Hero2 />
            <TrustCertifications />
            <WhyChooseUsSection />
            <ServicesCTABanner />
            <Footer />
        </div>
    )
}

export default aboutus